import { Box, BoxProps, styled } from "@mui/material";
import React, { ReactNode } from "react";

interface Props {
    children?: ReactNode
}

const StyledBox = styled(Box)<BoxProps>(({theme}) => ({
    margin: '0 auto',
    width: '100%',
    maxWidth: theme?.breakpoints?.values?.lg
}));

const ContentSection : React.FC<Props> = ({children}) => {
    return <StyledBox>{children}</StyledBox>
}

export default ContentSection;